import { SearchResults } from '@/components/pages/searchPage/SearchPage'
import { create } from 'zustand'

interface State {
  result?: SearchResults
}

type Action = {
  updateResult: (result?: SearchResults) => void
}

export const useSearchResultsStore = create<State & Action>((set) => ({
  result: undefined,
  updateResult: (result) => set(() => ({ result: result })),
}))
